import React, { useEffect } from "react";
import { graphql, Link } from 'gatsby';
import Layout from "../components/layout";
import FluidImage from "../components/fluidImage";
import FixedImage from "../components/fixedImage";
import WPLink from "../components/wpLink";
import Seo from 'gatsby-plugin-wpgraphql-seo';
import useModalState from '../helpers/modalState';

import * as styleSheet from "./droidal.module.scss"

const DroidalTemplate = (props) => {


  const [showAppointmentModal, setShowAppointmentModal] = useModalState();

  const droidalSrc = `https://appointments.westrockortho.com/westrock?fpid=${encodeURIComponent(process.env.GATSBY_DROIDAL_FPID)}&parentpage=${encodeURIComponent(process.env.GATSBY_DROIDAL_PARENT_PAGE)}&division=${encodeURIComponent(process.env.GATSBY_DROIDAL_DIVISION)}&phonenumber=${encodeURIComponent(process.env.GATSBY_DROIDAL_PHONE)}`;

  useEffect(() => {
    function handleMessage(event) {
      try {
        const data = JSON.parse(event.data);

        if (!data) return;

        window.dataLayer = window.dataLayer || [];

        /* REDIRECT FROM IFRAME */
        if (data.type === "navigate_parent" && data.url) {
          window.location.replace(data.url);
          return;
        }

        // Simple event
        if (data.event && typeof data.event === "string") {
          window.dataLayer.push({
            event: data.event
          });
        }

        // Array payload events
        else if (Array.isArray(data.event)) {
          window.dataLayer.push({
            event: data.event[0],
            value: data.event[1]
          });
        }

        // Object payload events
        else if (typeof data.event === "object") {
          const key = Object.keys(data.event)[0];

          window.dataLayer.push({
            event: key,
            value: data.event[key]
          });
        }
      } catch (e) {
        console.warn("Invalid message received", e);
      }
    }

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  function showModal(){
		if( !showAppointmentModal.modalOpen ){
			setShowAppointmentModal({modalOpen: true});
		}
	}

  function handleApptKeyDown(e) {
    if (e.keyCode === 13 || e.keyCode === 32) {
			setShowAppointmentModal({modalOpen: true});
		}
  }

  

	const {
		data: {
			droidal,
			droidal: {
				title,
			},
			home: {
				ACFHomePage: {
					hero: {
						callouts: {
							callout1: {
								heading: homeCalloutHeading,
								blurb: homeCalloutBlurb,
								makeAnAppointmentLinkText
							}
						}
					}
				}
			},
			options: {
				headerSection: {
					ACFHeaderOptions: {
						mainNavigationSettings: {
							mobileNavigationLogo
						} 
					}
				}

			},
			insurance: {
				nodes: insurances
			},
			rightArrowYellow,
			introBGMobile,
			introBGTablet,
			introBGDesktop,
			introBGXL,
			calloutBG: genericCalloutBG
		}
	} = props;

	return (
		<Layout>
			<Seo post={droidal} />
			<div className={styleSheet.top}>
				<div className={styleSheet.left}>
					<div className={styleSheet.lefttop}>
						{ mobileNavigationLogo && <Link to="/" className={styleSheet.logolink}><FluidImage image={mobileNavigationLogo} passedClass={styleSheet.logo} loading={"eager"} /></Link>}
					</div>
				</div>
				<div className={styleSheet.right}></div>
				<div className={styleSheet.center}>
					<h1 className={styleSheet.heading} dangerouslySetInnerHTML={{__html: title}}></h1>
				</div>
			</div>
			<div className={styleSheet.bottom}>
				<div className={styleSheet.iframeResponsiveContainerBooking}>
					<iframe
						id="droidal-iframe"
						title="Book your next appointment"
						src={droidalSrc}
						style={{ width: "100%", border: "none", height: "1400px" }}
					></iframe>
				</div>
			</div>
		</Layout>
	);
};

export const query = graphql`query ($id: String!) {
  droidal: wpPage(id: {eq: $id}) {
    id
    title
    seo {
      title
      metaDesc
      focuskw
      metaKeywords
      metaRobotsNoindex
      metaRobotsNofollow
      opengraphTitle
      opengraphDescription
      opengraphImage {
        altText
        sourceUrl
        srcSet
      }
      twitterTitle
      twitterDescription
      twitterImage {
        altText
        sourceUrl
        srcSet
      }
      canonical
      cornerstone
      schema {
        articleType
        pageType
        raw
      }
    }
    ACFPatientInfo {
      patientInfo {
        left {
          blurb
          requestAppointmentLink {
            title
            url
            target
          }
          insurancesHeading
          callout {
            backgroundImage {
              altText
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
                }
                publicURL
                extension
              }
            }
            blurb
            heading
            link {
              target
              title
              url
            }
          }
        }
        right {
          introContent {
            blurb
            heading
            link {
              target
              title
              url
            }
          }
          patientContent
          downloadLinks {
            linkTitle
            downloadLink
          }
        }
      }
    }
  }
  home: wpPage(isFrontPage: {eq: true}) {
    ACFHomePage {
      hero {
        callouts {
          callout1 {
            heading
            blurb
            makeAnAppointmentLinkText
          }
        }
      }
    }
  }
  options: wp {
    headerSection {
      ACFHeaderOptions {
        mainNavigationSettings {
          mobileNavigationLogo {
            altText
            localFile {
              childImageSharp {
                gatsbyImageData(width: 420, layout: CONSTRAINED)
              }
              publicURL
              extension
            }
          }
        }
      }
    }
  }
  rightArrowYellowOffsite: file(name: {eq: "arrow_offsite"}) {
    childImageSharp {
      gatsbyImageData(width: 10, layout: FIXED)
    }
  }
  rightArrowYellow: file(name: {eq: "arrow"}) {
    childImageSharp {
      gatsbyImageData(width: 9, layout: FIXED)
    }
  }
  arrowBlue: file(name: {eq: "arrow_blue"}) {
    childImageSharp {
      gatsbyImageData(width: 9, layout: FIXED)
    }
  }
  introBGMobile: file(name: {eq: "patientinfobg"}) {
    childImageSharp {
      gatsbyImageData(width: 699, layout: CONSTRAINED)
    }
  }
  introBGTablet: file(name: {eq: "patientinfobg"}) {
    childImageSharp {
      gatsbyImageData(width: 550, layout: CONSTRAINED)
    }
  }
  introBGDesktop: file(name: {eq: "patientinfobg"}) {
    childImageSharp {
      gatsbyImageData(width: 840, layout: CONSTRAINED)
    }
  }
  introBGXL: file(name: {eq: "patientinfobg"}) {
    childImageSharp {
      gatsbyImageData(layout: FULL_WIDTH)
    }
  }
  calloutBG: file(name: {eq: "callout_overlay_girl"}) {
    childImageSharp {
      gatsbyImageData(width: 295, layout: CONSTRAINED)
    }
  }
  insurance: allWpInsurance {
    nodes {
      ACFInsurance {
        logo {
          altText
          localFile {
            childImageSharp {
              gatsbyImageData(width: 420, layout: CONSTRAINED)
            }
            publicURL
            extension
          }
        }
      }
    }
  }
}
`;

export default DroidalTemplate;